"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
/**
 * Creates a React hook that is used to call an API method that updates
 * data on the server, such as a POST or DELETE method.
 * @param apiCall API method to call
 */
function useSideEffectApiHook(apiCall) {
    return useApiHook(apiCall, undefined, true, true);
}
exports.useSideEffectApiHook = useSideEffectApiHook;
/**
 * Creates a React hook that is used to call an API method
 * @param apiCall API method to call
 * @param cancelPreviousRequest Cancel previous running requests
 * @param skipInitialRequest Only calls API when triggered explicitly, avoids triggering API on initial render
 */
function useApiHook(apiCall, initialParams, cancelPreviousRequests = true, skipInitialRequest = false) {
    const [params, setParams] = react_1.default.useState(initialParams);
    const [apiData, setApiData] = react_1.default.useState();
    const [apiResponse, setApiResponse] = react_1.default.useState();
    const [isLoading, setIsLoading] = react_1.default.useState(!skipInitialRequest);
    const [isError, setIsError] = react_1.default.useState(false);
    const latestRequest = react_1.default.useRef(0);
    const initialRender = react_1.default.useRef(true);
    let currentRequest = latestRequest.current;
    const shouldAbort = () => cancelPreviousRequests && currentRequest !== latestRequest.current;
    react_1.useEffect(() => {
        if (initialRender.current && skipInitialRequest) {
            initialRender.current = false;
            return;
        }
        initialRender.current = false;
        if (shouldAbort())
            return;
        latestRequest.current = ++currentRequest;
        setIsLoading(true);
        apiCall(params).then(result => {
            if (shouldAbort())
                return;
            setApiData(result.data);
            setApiResponse(result);
            setIsError(!result.success);
        }).catch((e) => {
            console.error(e);
            setIsError(true);
        })
            .finally(() => {
            if (shouldAbort())
                return;
            setIsLoading(false);
        });
    }, [params]);
    return [{
            params,
            data: apiData,
            response: apiResponse,
            isLoading,
            isError
        }, setParams];
}
exports.useApiHook = useApiHook;
